<template>
  <div>
    <a-row>
      <g-master name="poll_category"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                ref="master"
                :parentData="parentData"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="poll_question"
                          :label="$t('Pregunta')"
                          :formItemConfig="fiOptions"
                          :cache="false"
                          :params="filtro_preguntas"
                          :decorator="['id_poll_question', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Operador')">
                <a-select
                  v-decorator="[
                    'operador',
                    { rules: [{ required: true, message: 'Valor requerido' }], initialValue: 'DIFFERENT' },
                  ]"
                >
                  <a-select-option value="EQUALS">
                    EQUALS
                  </a-select-option>
                  <a-select-option value="DIFFERENT">
                    DIFFERENT
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Valor')">
                <a-input
                  v-decorator="['valor', { rules: [{ required: false }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipo_pregunta: {h_lookup_type: 'TIPO_PREGUNTA'},
        filtro_preguntas: {},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'poll_rule_conds',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Operador', dataIndex: 'operador', sorter: true},
              {title: 'Valor', dataIndex: 'valor', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_poll_question'},
            {name: 'operador'},
            {name: 'valor'}
          ]
        }
      }
    },
    props: ['id', 'pollId'],
    mounted () {
      this.filtro_preguntas = {id_poll: this.pollId}
    },
    computed: {
      parentData () {
        return {
          id_poll_rule: this.id
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Poll/PollRuleConds.vue